import { useRegisterSW } from 'virtual:pwa-register/react';

import { Button } from '../components/ui/button';

export const ReloadPrompt = () => {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, r) {
      console.log('✅ Service Worker enregistré:', swUrl);

      if (r) {
        // Vérifier immédiatement s'il y a une mise à jour
        console.log('🔄 Vérification immédiate de mise à jour...');
        void r.update();

        // Puis vérifier toutes les 10 minutes
        setInterval(
          () => {
            console.log('🔄 Vérification périodique de mise à jour...');
            void r.update();
          },
          10 * 60 * 1000,
        );
      }
    },
    onRegisterError(error) {
      console.error('❌ Erreur enregistrement SW:', error);
    },
    onNeedRefresh() {
      console.log('⚠️ Nouvelle version disponible !');
    },
    onOfflineReady() {
      console.log('✅ App prête à fonctionner offline');
    },
  });

  const close = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
  };
  const reload = async () => {
    console.log("🔄 Rechargement de l'application...");
    await updateServiceWorker(true); // true = recharger immédiatement
  };
  return (
    <div className="m-0 p-0 w-0 h-0">
      {(offlineReady || needRefresh) && (
        <div className="fixed right-0 bottom-0 m-4 p-3 border border-accent-foreground/30 shadow-xl rounded-lg text-left bg-sidebar z-10">
          <div className="mb-2">
            {offlineReady ? (
              <span>App ready to work offline</span>
            ) : (
              <span>
                New content available, click on reload button to update.
              </span>
            )}
          </div>
          <div className="flex justify-end gap-2">
            {needRefresh && (
              <Button variant="destructive" onClick={reload}>
                Reload
              </Button>
            )}
            <Button variant="outline" onClick={close}>
              Close
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
